import iotDeviceFeatureConfigService from '../../../../services/iotDevice/iotDeviceFeatureConfigService';
import iotDeviceGlobalConfigService from '../../../../services/iotDevice/iotDeviceGlobalConfigService';
import iotDeviceSettingsService from '../../../../services/iotDevice/iotDeviceSettingsService';

const useAutoStartEnabled = (iotDevice) => {
    const isEnabledGlobally = iotDeviceGlobalConfigService.isGlobalAutoStart(iotDevice);
    const isFeatureEnabled = iotDeviceFeatureConfigService.isAutoStartEnabled();
    const isEnabled = iotDeviceSettingsService.isSettingAvailable(iotDevice, isEnabledGlobally, isFeatureEnabled);

    return isEnabled;
};

export default useAutoStartEnabled;
